"use memo"

import { ReactNode } from 'react'
import { AgxSpacer } from '@urbanx/agx.ui-components2'

const MarketingPanel = ({ children, fullWidth = false }: { children: ReactNode, fullWidth?: boolean }) => {
  return (
    <AgxSpacer
      direction="vertical"
      fill
      contentAlignment="start"
      padding="xl"
      gap="md"
      style={{
        borderRadius: 'var(--corner-md, 24px)',
        background: 'var(--bg-primary, #F5F8Fa)',
        gridColumn: fullWidth ? '1 / -1' : ''
      }}
    >
      {children}
    </AgxSpacer>
  )
}

export default MarketingPanel
